import React, {useEffect} from 'react';
import {Icons, DateContext, UI} from 'components';
import {Card} from './card';
import {partialRight, fullday, get, map, pluralize, size, groupBy, openPopup, useNamedSelector, useDrop, overEvery} from 'helpers';
import {drop} from 'store/calendar';
import css from './sticky-items.module.scss';

export function StickyItems({ date, size, selector }) {
  const capacity = get({ 1: 4, 3: 2 }, size, 1);
  const activities = useNamedSelector(selector, {
    date,
    filter: overEvery(
      useNamedSelector('settings.shareStatusFilter', {context: 'activities'}),
      useNamedSelector('activities.externalCalendarsFilter')
    )
  });
  const values = {
    time: null,
    duration: /allDay/.test(selector) ? fullday : null
  };
  return (
    <div className={css('wrapper')} {...useDrop(partialRight(drop, date, values), ({type}) => type.match(/activity/))}>
      { activities.length <= capacity && activities.map((activity, index) =>
        <Card
          {...activity}
          key={activity.id}
          isAllDay
          style={{
            bottom: 0,
            left: 100*index/activities.length + '%',
            position: 'absolute',
            right: 100*(activities.length - index - 1)/activities.length + "%",
            top: 0,
          }}
        />
      ) }
      { activities.length > capacity &&
        <Collapsed activities={activities} selector={selector} date={date} capacity={capacity} />
      }
    </div>
  );
}

export function Collapsed({ activities, date, selector, capacity }) {
  const types = groupBy(activities, item => {
    if (item.goal) {
      return item.goal.parent_id ? 'milestone' : 'goal';
    }
    return 'activity';
  });

  if (size(types) == 3) {
    types['goal & milestone'] = types.goal.concat(types.milestone);
    delete types.goal;
    delete types.milestone;
  }

  return (
    <UI.Card className={css.collapsed} onCalendar onClick={openPopup(Popup, {date, selector, capacity, className: 'adjacent'})}>
      { map(types, (array, type) =>
        <span key={type}>
          { array.length } { pluralize(type, array.length) }
        </span>
      ) }
      <Icons.Chevron className="secondary" />
    </UI.Card>
  );
}

export function Popup({ date, selector, popup, capacity }) {
  popup.setClassName(css.popup);
  const activities = useNamedSelector(selector, { date });
  useEffect(() => {
    if (activities.length <= capacity) {
      popup.close();
    }
  }, [ activities.length ]);
  return (
    <DateContext.Provider value={date}>
      <div className={css.cards}>
        { activities.map(activity =>
          <Card key={activity.id} {...activity} isAllDay />
        ) }
      </div>
    </DateContext.Provider>
  );
}
